/**
 * Human-readable message from anything a `catch` receives — an axios error
 * carrying the API's `{ error }` body, a plain Error, or something else.
 */
export function apiError(e: unknown, fallback = 'Something went wrong'): string {
  if (typeof e === 'object' && e !== null) {
    const ax = e as { response?: { data?: { error?: unknown; message?: unknown } }; message?: unknown };
    const body = ax.response?.data;
    if (body && typeof body.error === 'string' && body.error) return body.error;
    if (body && typeof body.message === 'string' && body.message) return body.message;
    if (typeof ax.message === 'string' && ax.message) return ax.message;
  }
  return fallback;
}

/** Error code the API attaches (e.g. 'OTP_INVALID'), if any. */
export function apiErrorCode(e: unknown): string | undefined {
  const ax = e as { response?: { data?: { error_code?: unknown } } } | null;
  const code = ax?.response?.data?.error_code;
  return typeof code === 'string' ? code : undefined;
}

/** HTTP status of a failed request, if any. */
export function apiStatus(e: unknown): number | undefined {
  const ax = e as { response?: { status?: unknown } } | null;
  const s = ax?.response?.status;
  return typeof s === 'number' ? s : undefined;
}
